webpackJsonp([35783957827783],{

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(86);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(87);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	exports.default = mapProps;

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(199);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _wrapDisplayName = __webpack_require__(87);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _setDisplayName = __webpack_require__(86);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _mapProps = __webpack_require__(198);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withProps = function withProps(input) {
	  var hoc = (0, _mapProps2.default)(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	exports.default = withProps;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(197);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'e2winwg0'
	})('align-items:center;display:flex;flex-flow:row wrap;justify-content:space-evenly;list-style:none;margin:-30px 0 0 0;li{font-size:0;margin:30px 0 0 0;min-width:160px;text-align:center;}img{margin:0;}');
	
	var ImageStrip = function ImageStrip(_ref) {
	  var images = _ref.images;
	  return _react2.default.createElement(
	    Container,
	    null,
	    images.edges.map(function (img, index) {
	      return _react2.default.createElement(
	        'li',
	        { key: index },
	        _react2.default.createElement('img', { alt: img.node.name, src: img.node.logo.publicURL })
	      );
	    })
	  );
	};
	
	ImageStrip.propTypes = {
	  images: _propTypes2.default.object.isRequired
	};
	
	exports.default = ImageStrip;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LargeLinkButton = exports.ButtonCss = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withProps = __webpack_require__(42);
	
	var _withProps2 = _interopRequireDefault(_withProps);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _SmartLink = __webpack_require__(92);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	var _styleHelpers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonCss = /*#__PURE__*/exports.ButtonCss = (0, _reactEmotion.css)((0, _styleHelpers.regularFontFamily)(), '\n  background:#4caf50;border:none;border-radius:9999px;color:#fff;display:inline-block;font-size:12px;height:64px;letter-spacing:2.4px;line-height:64px;padding:0;text-align:center;text-decoration:none;text-transform:uppercase;');
	
	var LinkButton = /*#__PURE__*/(0, _reactEmotion2.default)(_SmartLink2.default, {
	  target: 'e16q4ren0'
	})(ButtonCss, ';');
	
	exports.default = LinkButton;
	var LargeLinkButton = /*#__PURE__*/exports.LargeLinkButton = (0, _reactEmotion2.default)(LinkButton, {
	  target: 'e16q4ren1'
	})('font-size:18px;letter-spacing:3.6px;');

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SmartLink = function SmartLink(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      to = _ref.to,
	      href = _ref.href,
	      other = _objectWithoutProperties(_ref, ['children', 'className', 'to', 'href']);
	
	  return href ? _react2.default.createElement(
	    'a',
	    _extends({ className: className, href: href }, other),
	    children
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    _extends({ className: className, to: to }, other),
	    children
	  );
	};
	
	exports.default = SmartLink;
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styleHelpers = __webpack_require__(9);
	
	var _Page = __webpack_require__(45);
	
	var _Hero = __webpack_require__(29);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _LinkButton = __webpack_require__(67);
	
	var _Wrapper = __webpack_require__(24);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _ImageStrip = __webpack_require__(341);
	
	var _ImageStrip2 = _interopRequireDefault(_ImageStrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroContent = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eeifqlt0'
	})('color:#fff;min-height:400px;padding-top:10px;h1{font-size:55px;text-transform:uppercase;span{', (0, _styleHelpers.regularFontFamily)('light'), '\n      display:block;font-size:40px;margin-top:15px;}strong{font-weight:bold;}}');
	
	var ActionButton = /*#__PURE__*/(0, _reactEmotion2.default)(_LinkButton.LargeLinkButton, {
	  target: 'eeifqlt1'
	})('margin-top:50px;width:260px;');
	
	var SupportedSoftwares = /*#__PURE__*/(0, _reactEmotion2.default)(_Wrapper2.default, {
	  target: 'eeifqlt2'
	})('padding-top:50px;padding-bottom:50px;text-align:center;p{color:#2c2c2c;font-size:18px;margin-bottom:60px;text-transform:uppercase;}');
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Page.PageContainer,
	    null,
	    _react2.default.createElement(
	      _Hero2.default,
	      { heroImage: data.heroImage },
	      _react2.default.createElement(
	        HeroContent,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Save 80% more time ',
	          _react2.default.createElement(
	            'span',
	            null,
	            'managing ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'invoices'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ActionButton,
	          { href: '#sign-up' },
	          'Learn More'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      SupportedSoftwares,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Chouxbox works with your accounting software'
	      ),
	      _react2.default.createElement(_ImageStrip2.default, { images: data.supportedSoftwares })
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-297c3cc84b9cab9b361b.js